import { Loader2 } from 'lucide-react';

interface SuspenseFallbackProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
}

export function SuspenseFallback({ 
  message = 'Loading...', 
  size = 'md',
  fullScreen = false 
}: SuspenseFallbackProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  };

  const containerClasses = fullScreen 
    ? 'flex items-center justify-center min-h-screen bg-base'
    : 'flex items-center justify-center p-8';

  return (
    <div className={containerClasses}>
      <div className="flex flex-col items-center space-y-4">
        <Loader2 className={`${sizeClasses[size]} animate-spin text-accent-500`} />
        <p className="text-sm text-secondary">{message}</p>
      </div>
    </div>
  );
}

// Skeleton components for different views
export function DashboardSkeleton() {
  return (
    <div className="space-y-6 p-6">
      <div className="h-8 skeleton w-1/3" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="h-32 skeleton" />
        ))}
      </div>
    </div>
  );
}

export function PlanModeSkeleton() {
  return (
    <div className="space-y-6 p-6">
      <div className="h-8 skeleton w-1/4" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-4">
          <div className="h-64 skeleton" />
          <div className="h-32 skeleton" />
        </div>
        <div className="space-y-4">
          <div className="h-48 skeleton" />
          <div className="h-32 skeleton" />
        </div>
      </div>
    </div>
  );
}

export function BuildModeSkeleton() {
  return (
    <div className="space-y-6 p-6">
      <div className="h-8 skeleton w-1/4" />
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        <div className="lg:col-span-3 space-y-4">
          <div className="h-48 skeleton" />
          <div className="h-32 skeleton" />
        </div>
        <div className="space-y-4">
          <div className="h-64 skeleton" />
        </div>
      </div>
    </div>
  );
}

export function ViewSkeleton() {
  return (
    <div className="space-y-4 p-6">
      <div className="h-6 skeleton w-1/3" />
      <div className="h-64 skeleton" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="h-32 skeleton" />
        <div className="h-32 skeleton" />
      </div>
    </div>
  );
}
